import { render, staticRenderFns } from "./SsoUserCard.vue?vue&type=template&id=bb7d9904&scoped=true"
import script from "./SsoUserCard.vue?vue&type=script&lang=js"
export * from "./SsoUserCard.vue?vue&type=script&lang=js"
import style0 from "./SsoUserCard.vue?vue&type=style&index=0&id=bb7d9904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7d9904",
  null
  
)

export default component.exports